module.exports = __webpack_public_path__ + "static/media/favoritesShows1.9074aaef.jpg";